import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CarrierProfileService,
  CarrierModel,
  CarrierBusinessRequest,
  AnyValueModelUUID
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CarrierProfileApiService {
  constructor(private apiService: CarrierProfileService) {}

  public editBusiness(carrierId: string, body: CarrierBusinessRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.carrierProfileEditBusiness(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editInsurance(carrierId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.carrierProfileEditInsurance(carrierId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editSS4(carrierId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.carrierProfileEditSs4(carrierId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getProfile(carrierId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.carrierProfileGet(carrierId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
